<template>
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClick" :before-leave="tabsBefore">
        <el-tab-pane label="基础信息" name="first">
          <div>
            <BaseInfo ref="baseInfoRef" v-model="form" 
            :row.sync="form"
            @success="successHandler"
            @init="initForm"
            :model="model"></BaseInfo>
          </div>
        </el-tab-pane>
        <el-tab-pane label="服务介绍" name="second">
          <div>
            <div
            v-if="model === 'view'"
              style="padding: 10px; border: 1px solid #efefef"
              v-html="form.introduce"
            ></div>
            <AvueUeditor
              v-else
              v-model="form.introduce"
              :options="avueUeditorOptions"
            ></AvueUeditor>
          </div>
        </el-tab-pane>
        <el-tab-pane label="服务标准" name="third">
          <div>
            <div
            v-if="model === 'view'"
              style="padding: 10px; border: 1px solid #efefef"
              v-html="form.standard"
            ></div>
            <AvueUeditor
              v-else
              v-model="form.standard"
              :options="avueUeditorOptions"
            ></AvueUeditor>
          </div>
        </el-tab-pane>
        <el-tab-pane label="其他暖心服务" name="four">
          <div>
            <div
            v-if="model === 'view'"
              style="padding: 10px; border: 1px solid #efefef"
              v-html="form.additional"
            ></div>
            <AvueUeditor
              v-else
              v-model="form.additional"
              :options="avueUeditorOptions"
            ></AvueUeditor>
          </div>
        </el-tab-pane>
        <el-tab-pane label="服务案例" name="five">
          <div>
          <div
           v-if="model === 'view'"
            style="padding: 10px; border: 1px solid #efefef"
            v-html="form.serviceCase"
          ></div>
          <AvueUeditor
            v-else
            v-model="form.serviceCase"
            :options="avueUeditorOptions"
          ></AvueUeditor>
          </div>
        </el-tab-pane>
        <el-tab-pane label="注意事项" name="six">
          <div
           v-if="model === 'view'"
            style="padding: 10px; border: 1px solid #efefef"
            v-html="form.note"
          ></div>
          <AvueUeditor
            v-else
            v-model="form.note"
            :options="avueUeditorOptions"
          ></AvueUeditor>
        </el-tab-pane>
      </el-tabs>
      <div style="    text-align: right;" v-if="model != 'view'">
        <el-button
          type="primary"
          icon="el-icon-circle-plus-outline"
          @click="saveRecord"
          size="small"
        >
          {{ model == 'add' ? '提交' : '修改' }}
        </el-button>
        <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small">
          取消
        </el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { getProjectList } from '@/api/crmedical/project/project';
import { getDictionary } from '@/api/common.js';
import BaseInfo from './baseInfo.vue';
import FamilyInfo from './familyInfo.vue';
import HealthInfo from './healthInfo.vue';
import NursingTasksInfo from './nursingTasksInfo.vue';
import CateringBedsInfo from './cateringBedsInfo.vue';
import DocumentInfo from './documentInfo.vue';
import MedicalTestInfo from './medicalTestInfo.vue';
import { removeStore,getStore } from '@/util/store';
import { setStore } from '@/util/store';
import {
  getMatetial,
  getTotalWarehouseWarnSetting,
  stockWarnSave,
  getWarehouseWarnSetting,
} from '../api/serveItemManage';
export default {
  components: { BaseInfo,FamilyInfo,HealthInfo,NursingTasksInfo,CateringBedsInfo,DocumentInfo,MedicalTestInfo},
  props: {
    row: {
      default: {},
    },
    nursinghomeId: {},
    nursinghomeName: {},
    projectId: {},
    model: {
      default: 'add',
    },
  },
  data() {
    return {
        activeFlag:true,
      projectList: [],
      activeName: 'first',
      form: {
        nursinghomeId: '',
        name: '',
        // birthday: '123',
        idNumber: '',
        content:'',
        introduce:''
      },
      formRules: {
        // idNumber: [{ required: true, message: '物料名称不能为空', trigger: 'change' }],
        // consumableName: [{ required: true, message: '物料名称不能为空', trigger: 'change' }],
        // nursinghomeId: [{ required: false, message: '项目名称不能为空', trigger: 'change' }],
        // consumableCode: [{ required: true, message: '物料编码不能为空', trigger: 'change' }],
      },
      // 富文本配置
      avueUeditorOptions: {
        action: "/api/v4ward/oss/customEndpoint/put-file",
        props: {
          res: "data",
          url: "url",
        },
        customConfig: {
          menus: [
            "head", // 标题
            "bold", // 粗体
            "fontSize", // 字号
            "fontName", // 字体
            "italic", // 斜体
            "underline", // 下划线
            "strikeThrough", // 删除线
            "foreColor", // 文字颜色
            "backColor", // 背景颜色
            "link", // 插入链接
            "list", // 列表
            "justify", // 对齐方式
            "quote", // 引用
            "emoticon", // 表情
            'image',  // 插入图片
            "table", // 表格
            // 'video',  // 插入视频
            "code", // 插入代码
            "undo", // 撤销
            "redo", // 重复
          ],
        },
      },
      matetialList: [],
    };
  },
  created() {
    this.initData();
  },
  mounted() {},
  watch: {},
  methods: {
    successHandler(){
      this.$emit('stepsuccess');
    },
     initData() {
      getProjectList().then((res) => {
        this.projectList = res.data;
      });
      if (this.model == 'add') {
        this.form.nursinghomeId = this.nursinghomeId;
        this.form.nursinghomeName = this.nursinghomeName;
        this.form.projectId = this.projectId;
        //  getMatetial({ nursinghomeId: this.form.nursinghomeId }).then((res) => {
        //   this.matetialList = res.data;

        //   if (this.matetialList.length > 0) {
        //     this.form.consumableId = this.matetialList[0].id;
        //   }
        // });
        //通过物料id获取仓库数据
      } else {
        this.form = this._.cloneDeep(this.row);;
        let self = this;
        console.log(self.form,"self.form============>");
        console.log(self.form.elderlyId,"self.form.elderlyId============>");
        this.form.nursinghomeName = this.nursinghomeName;
        setStore({
              name: 'elderId',
              content: self.form.id
            })
      }
    },
    initForm(val){
      this.form = this._.cloneDeep(val);
    },
    saveRecord() {
      // if(){

      // }
      let self = this;
      console.log("this.activeName===========>",this.activeName);
      console.log("saveRecord===========>",this.form);
      // if(this.activeName === 'first'){
        this.activeFlag = this.$refs.baseInfoRef.saveRecord(()=>{

      removeStore({
        name:'elderId'
      });
      this.$emit('cancle');
          // this.activeName = 'second'
          // setTimeout(()=>{
            // self.activeName = 'second'
            // self.$refs.FamilyInfoRef.initData()
          // })
        })
      // }
      // if(this.activeName === 'second'){
      //   // setTimeout(()=>{
      //     this.activeName = 'third'
      //       this.$refs.HealthInfoRef.initData()
      //   // })
      //   // this.activeFlag = this.$refs.FamilyInfoRef.saveRecord()
      // }
      // if(this.activeName === 'third'){
      //   this.activeFlag = this.$refs.HealthInfoRef.saveRecord(()=>{

      //     // this.activeName = 'second'
      //     // setTimeout(()=>{
      //       self.activeName = 'fourth'
      //       self.$refs.MedicalTestInfoRef.initData()
      //     // })
      //   })
      //   // this.$refs.HealthInfoRef.initData()
      //   // this.activeName = 'fourth'
      // }
      // if(this.activeName === 'fourth'){
      //   this.activeFlag = this.$refs.MedicalTestInfoRef.saveRecord(()=>{

      //     // this.activeName = 'second'
      //     // setTimeout(()=>{
      //       self.activeName = 'five'
      //       self.$refs.CateringBedsInfoRef.initData()
      //     // })
      //   })
      //   // this.$refs.MedicalTestInfoRef.initData()
      //   // this.activeName = 'five'
      // }
      // if(this.activeName === 'five'){
      //   this.activeFlag = this.$refs.CateringBedsInfoRef.saveRecord()
      //   // this.$refs.CateringBedsInfoRef.initData()
      // }
     
    },
    tabsBefore(){
        // console.log(this.activeName)
        // console.log(getStore({name:'elderId'}));
        
        // this.activeFlag = this.$refs.baseInfoRef.saveRecord()
        // if(getStore({name:'elderId'})&&(getStore({name:'elderId'})+'')!=='undefined'){
        //   return true;
        // }else{
        //   return false;
        // }
        // if( this.activeFlag){
        //     return true
        // }else{
        //     return false
        // }
    },
    handleClick(){
      
        // this.$refs.baseInfoRef.initData()
        console.log("handleClick==============>",this.form);
      // if(this.activeName === 'first'){
      //   this.$refs.baseInfoRef.initData()
      // }
      // if(this.activeName === 'second'){
      //   // this.$refs.FamilyInfoRef.initData()
      // }
      // if(this.activeName === 'third'){
      //   // this.$refs.HealthInfoRef.initData()
      //   // this.activeName = 'fourth'
      // }
      // if(this.activeName === 'fourth'){
      //   // this.$refs.MedicalTestInfoRef.initData()
      //   // this.activeName = 'five'
      // }
      // if(this.activeName === 'five'){
      //   // this.$refs.CateringBedsInfoRef.initData()
      // }
        console.log(this.activeName)
    },
    cancleRecord() {
      removeStore({
        name:'elderId'
      });
      this.$emit('cancle');
    },
  },
};
</script>
<style scoped>
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
</style>
